import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const PaymentSuccessHero = () => (
  <div className="text-center mb-8" data-testid="payment-success-hero">
    <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-brand-primary to-brand-accent mb-6 animate-bounce">
      <CheckCircle2 size={48} className="text-white" aria-hidden="true" />
    </div>
    <h1 className="text-4xl md:text-5xl font-black mb-4 bg-gradient-to-r from-white via-brand-primary to-brand-accent bg-clip-text text-transparent">
      Payment Successful
    </h1>
    <p className="text-xl text-text-secondary">
      Welcome to your capability journey with ZEEVA Life
    </p>
  </div>
);

export default PaymentSuccessHero;
